import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import styles from './DraftJobAssistance.module.css'
import { formatUSPhoneNumber } from '@/utils/phone-number-util'
import {
  CardItemContent,
  CardList,
  CardListItem,
  CardSubtitle,
  CardTitle,
} from '@/components/Card'
import { Icon } from '@/components/Icon'

interface DraftJobAssistanceDialogProps {
  isOpen: boolean
  onClose: () => void
  phoneNumber: string
  callCenterHours: string
}

export function DraftJobAssistanceDialog({
  isOpen,
  onClose,
  phoneNumber,
  callCenterHours,
}: DraftJobAssistanceDialogProps) {
  return (
    <ModalDialog size="lg" isOpen={isOpen} onClose={onClose}>
      <ModalDialogHeader textAlign="center">
        <ModalDialogTitle>How would you like to continue?</ModalDialogTitle>
        <ModalDialogDescription>
          Choose the option that works best for you
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogContent>
        <CardList>
          <CardListItem
            onAction={() => window.open(`tel:${phoneNumber}`, '_self')}
          >
            <div className={styles.root}>
              <CardItemContent
                icon={<Icon name="call-start-call" variant="surface-variant" />}
              >
                <div className={styles.content}>
                  <CardTitle>Assisted Onboarding</CardTitle>

                  <CardSubtitle>
                    <p className={styles.phoneNumber}>
                      {formatUSPhoneNumber(phoneNumber)}
                    </p>

                    <div className={styles.schedule}>
                      Assistance available: {callCenterHours}
                    </div>
                  </CardSubtitle>
                </div>
              </CardItemContent>
            </div>
          </CardListItem>

          <CardListItem onAction={onClose}>
            <CardItemContent
              icon={<Icon name="nav-account" variant="active" />}
            >
              <div className={styles.content}>
                <CardTitle>Self-Onboard</CardTitle>
                <CardSubtitle>
                  Start on your own by answering a few quick questions
                </CardSubtitle>
              </div>
            </CardItemContent>
          </CardListItem>
        </CardList>
      </ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button label="Close" variant="outline" onPress={onClose} />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
